import { type DeviceType } from '@/utils/devices/DeviceEventBus';
import { type FC } from 'react';
import { RiBarcodeBoxLine, RiCpuLine, RiRulerLine, RiScales3Line } from 'react-icons/ri';

interface DeviceTypeIconProps {
  deviceType: DeviceType | undefined;
  className?: string;
  size?: number;
}

const DEFAULT_SIZE = 20;

/**
 * Renders the glyph associated with a device type — scales for a Balance, a
 * ruler for Calipers, a barcode for an ID Reader — falling back to a generic CPU
 * glyph when the type is missing or unrecognised.
 */
const DeviceTypeIcon: FC<DeviceTypeIconProps> = ({ deviceType, className, size = DEFAULT_SIZE }) => {
  switch (deviceType) {
    case 'Balance':
      return <RiScales3Line className={className} size={size} />;
    case 'Calipers':
      return <RiRulerLine className={className} size={size} />;
    case 'ID Reader':
      return <RiBarcodeBoxLine className={className} size={size} />;
    default:
      return <RiCpuLine className={className} size={size} />;
  }
};

export default DeviceTypeIcon;
